import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=44190680"
import script from "./Presupuestos.vue?vue&type=script&lang=js"
export * from "./Presupuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports